/* eslint-disable @typescript-eslint/no-unused-vars */
import { FileDownloader } from '@price-card/providers/file-downloader.provider';

export class BrowserFileDownloader implements FileDownloader {
  handle(file: Blob, filename: string): void {
    const url = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}
